import { useLayout } from '../../context/LayoutContext';

interface IProps {
  icon?: string;
  title: string | React.ReactNode;
}

const HeaderLeft: React.FC<IProps> = ({ icon, title }) => {
  const { toggleMobileMenu } = useLayout();

  return (
    <div className='header-left nowrap no-select flex flex-v-center'>
      <button
        type='button'
        className='pointer mobile-only-block'
        onClick={toggleMobileMenu}
        style={{ marginRight: '15px', background: 'none', border: 'none' }}
      >
        <i className='material-icons' style={{ fontSize: '24px' }}>
          menu
        </i>
      </button>
      {icon && (
        <button type='button' className='pointer responsive-hide-inline'>
          <i className='material-icons'>{icon}</i>
        </button>
      )}
      {typeof title === 'string' ? <h1>{title}</h1> : title}
    </div>
  );
};

export default HeaderLeft;
